'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
var Modal = require('../Modal/Modal.js');
var Table = require('../Table/Table.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-datasheet',
    cHorizontal = "".concat(CLASSNAME, "--horizontal"),
    cnTooltip = "".concat(CLASSNAME, "__tooltip"),
    cnTooltipModal = "".concat(cnTooltip, "--modal"),
    cnTooltipLink = "".concat(cnTooltip, "__link"),
    cnType = "".concat(CLASSNAME, "--type"),
    cnContentWrapper = "".concat(CLASSNAME, "__content-wrapper"),
    cnDataWrapper = "".concat(CLASSNAME, "__data-wrapper"),
    cnTableWrapper = "".concat(CLASSNAME, "__table-wrapper"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnImage = "".concat(CLASSNAME, "__image"),
    cnTable = "".concat(CLASSNAME, "__table"),
    cnFooter = "".concat(CLASSNAME, "__footer"),
    cnDownload = "".concat(CLASSNAME, "__download"),
    cnDownloadFirst = "".concat(cnDownload, " ").concat(cnDownload, "--first"),
    cnIcons = "".concat(CLASSNAME, "__icons"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnModal = "".concat(CLASSNAME, "__modal"),
    cnModalContent = "".concat(cnModal, "__content");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Datasheet(_ref) {
  var benefitsTitle = _ref.benefitsTitle,
      className = _ref.className,
      details = _ref.details,
      downloadButtonTitle = _ref.downloadButtonTitle,
      etn = _ref.etn,
      horizontal = _ref.horizontal,
      image = _ref.image,
      infoButtonTitle = _ref.infoButtonTitle,
      keybenefits = _ref.keybenefits,
      mobile = _ref.mobile,
      onClickDownload = _ref.onClickDownload,
      productsheet = _ref.productsheet,
      title = _ref.title,
      typeDescription = _ref.typeDescription,
      typeLabel = _ref.typeLabel,
      typeName = _ref.typeName,
      typeTitle = _ref.typeTitle,
      type = _ref.type;

  var _useState = React.useState(),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      benefitsOpen = _useState2[0],
      setBenefitsOpen = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2),
      descriptionOpen = _useState4[0],
      setDescriptionOpen = _useState4[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, CLASSNAME, "".concat(cnType, "-").concat(type), _rollupPluginBabelHelpers.defineProperty({}, cHorizontal, horizontal))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnTooltip
  }, typeName, typeDescription && /*#__PURE__*/React__default.createElement("a", {
    href: "#",
    className: cnTooltipLink,
    onClick: function onClick(e) {
      e.preventDefault();
      setDescriptionOpen(true);
    }
  }, typeLabel)), /*#__PURE__*/React__default.createElement("div", {
    className: cnContentWrapper
  }, /*#__PURE__*/React__default.createElement("img", {
    src: image,
    alt: title,
    className: cnImage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cnDataWrapper
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: cnTitle
  }, title, etn && /*#__PURE__*/React__default.createElement("br", null), etn), /*#__PURE__*/React__default.createElement("div", {
    className: cnTableWrapper
  }, mobile || !horizontal ? /*#__PURE__*/React__default.createElement(Table, {
    className: cnTable,
    sideHeader: true,
    items: details
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Table, {
    className: cnTable,
    sideHeader: true,
    items: details.slice(0, Math.round(details.length / 2))
  }), /*#__PURE__*/React__default.createElement(Table, {
    className: cnTable,
    sideHeader: true,
    items: details.slice(Math.round(details.length / 2), details.length - 1)
  }))), /*#__PURE__*/React__default.createElement("footer", {
    className: cnFooter
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnIcons
  }, keybenefits.map(function (benefit, i) {
    return /*#__PURE__*/React__default.createElement("img", {
      key: i,
      className: cnIcon,
      src: benefit.iconUrl
    });
  })), keybenefits && keybenefits.length ? /*#__PURE__*/React__default.createElement(ButtonLink, {
    tagName: "a",
    title: infoButtonTitle,
    iconLeft: "info",
    className: cnDownloadFirst,
    onClick: function onClick() {
      setBenefitsOpen(true);
    }
  }) : null, productsheet && /*#__PURE__*/React__default.createElement(ButtonLink, {
    tagName: "a",
    title: downloadButtonTitle,
    iconLeft: "download",
    className: cnDownload,
    link: productsheet,
    onClick: onClickDownload
  })))), (typeTitle || typeDescription) && /*#__PURE__*/React__default.createElement(Modal, {
    open: descriptionOpen,
    onClose: function onClose() {
      return setDescriptionOpen(false);
    },
    showCloseButton: true,
    className: cnModal
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnModalContent, "".concat(cnType, "-").concat(type))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnTooltip, cnTooltipModal)
  }, typeName), /*#__PURE__*/React__default.createElement("h3", null, typeTitle), /*#__PURE__*/React__default.createElement(RichText, {
    content: typeDescription
  }))), /*#__PURE__*/React__default.createElement(Modal, {
    open: benefitsOpen,
    onClose: function onClose() {
      return setBenefitsOpen(false);
    },
    showCloseButton: true,
    className: cnModal
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnModalContent, "".concat(cnType, "-").concat(type))
  }, /*#__PURE__*/React__default.createElement("h3", null, benefitsTitle), /*#__PURE__*/React__default.createElement("ul", null, keybenefits.map(function (_ref2) {
    var text = _ref2.text,
        textNo = _ref2.textNo;
    return /*#__PURE__*/React__default.createElement("li", {
      key: textNo
    }, text);
  })))));
}
Datasheet.propTypes = {
  /** */
  benefitsTitle: PropTypes.string,

  /** Additional classname */
  className: PropTypes.string,

  /** */
  details: PropTypes.array,

  /** */
  downloadButtonTitle: PropTypes.string.isRequired,

  /** ETN of battery */
  etn: PropTypes.string,

  /** True if should be displayed horizontal */
  horizontal: PropTypes.bool,

  /** String to battery image */
  image: PropTypes.string,

  /** Text for info button */
  infoButtonTitle: PropTypes.string,

  /** */
  keybenefits: PropTypes.array,

  /** True if should be displayed for mobile */
  mobile: PropTypes.bool,

  /** Callback function on download button click */
  onClickDownload: PropTypes.func,

  /** String to productsheet url */
  productsheet: PropTypes.string,

  /** Title of sheet */
  title: PropTypes.string.isRequired,

  /** */
  typeDescription: PropTypes.string,

  /** */
  typeLabel: PropTypes.string,

  /** */
  typeName: PropTypes.string.isRequired,

  /** */
  typeTitle: PropTypes.string,

  /** Type defines sheet color */
  type: PropTypes.oneOf(['recommendation', 'upgrade', 'alternative', 'default']).isRequired
};
Datasheet.defaultProps = {
  benefitsTitle: '',
  details: [],
  etn: '',
  infoButtonTitle: '',
  keybenefits: [],
  onClickDownload: function onClickDownload() {
    return void 0;
  },
  type: 'default'
};

module.exports = Datasheet;
